/* eslint-disable react-hooks/exhaustive-deps */
import MenuIcon from "@mui/icons-material/Menu";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { Paper, Typography, useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { openDrawer } from "../../state/slices/menu.js";
import { readStoredObject } from "../../state/storage";
import BroadCrumb from "./BroadCrumb.jsx";
import moment from "jalali-moment";

import DarkModeSwitch from "./darkModeSwitch.jsx";

const PageTitle = ({
  title,
  backBtn = false,
  broadCrumb = [],
  buttonInfo = false,
  hideTitle = true,
  buttonInfo2 = false,
  buttonInfo3 = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userInfo, setuserInfo] = useState({});

  useEffect(() => {
    if (localStorage.getItem("s")) {
      setuserInfo(readStoredObject("s") || {});
    }
  }, [localStorage.getItem("s")]);
  const isDesktop = useMediaQuery("(min-width:900px)");
  return (
    <Paper
      elevation={0}
      sx={{
        display: "flex",
        /*      flexDirection: { xs: "column", sm: "row" }, */
        py: 2,
        alignItems: "center",
        gap: { xs: 0.5, sm: 2.5 },

        height: { md: "50px" },
        borderBottom: "1px solid #dbdfea",
        mb: "10px",
      }}
      className="md:px-8 p-1 pr-5 pl-1"
    >
      {!isDesktop && (
        <MenuIcon
          sx={{
            color: (theme) =>
              theme.palette.mode === "light" ? "rgba(0, 0, 0, 0.81)" : "#fff",
            fontSize: "2em",
            mr: 1,
            cursor: "pointer",
          }}
          onClick={() => {
            dispatch(openDrawer(true));
          }}
        />
      )}

      {hideTitle && (
        <div className="overflow-x-auto overflow-y-hidden pl-3">
          <div className="w-full min-w-max">
            <BroadCrumb
              current={title}
              links={[
                {
                  title: "داشبورد",
                  path: "/",
                },
                ...broadCrumb,
              ]}
            />
          </div>
        </div>
      )}

      <div style={{ flexGrow: 1 }} />
      <div className="md:flex hidden items-center gap-2">
      
        <Box
          sx={{
            background: (theme) =>
              theme.palette.mode === "light" ? "#f0f2f5" : "#1a2935",
          }}
          className="flex mx-5 gap-2 rounded-3xl py-3 px-7"
        >
          <span className="text-xs">امروز :‌ </span>
          <span className="text-xs">
            {moment(new Date(), "YYYY-MM-DD HH:mm:ss").format("dddd")}
          </span>
          <span className="text-xs">
            {new Intl.DateTimeFormat("fa-IR", {
              month: "short",
              day: "numeric",
            }).format(new Date())}
          </span>
        </Box>
        <DarkModeSwitch />
        <div className="flex items-center justify-center md:w-[30px] md:h-[30px] w-[25px] h-[25px] rounded-full border-2 border-[#f0f2f5]">
          <PersonOutlineIcon
            sx={{ color: "#cfcfcf", fontSize: { md: "25px", xs: "15px" } }}
          />
        </div>

        <div className="md:flex flex-col hidden">
          <Typography
            sx={{
              fontSize: { md: "0.8rem !important", xs: "1rem !important" },
              color: (theme) =>
                theme.palette.mode === "light" ? "#001ee4" : "#90caf9",
              fontWeight: 900,
            }}
          >
            {userInfo?.access || "ادمین"}
          </Typography>
          <div className="flex items-center gap-2">
            <Typography
              sx={{
                fontSize: { md: "0.75rem !important", xs: "1rem !important" },
              }}
            >
              {userInfo?.fname} {userInfo?.lname}
            </Typography>
            {/*   <KeyboardArrowDownIcon sx={{ fontSize: "0.8rem !important" }} /> */}
          </div>
        </div>
      </div>
    </Paper>
  );
};

export default PageTitle;
